import { LEGACY_CARDS } from "@/data/legacy_data.js";

export default {
  name: "CalculatorInputs",

  data() {
    return ({
      ui_labels: {
        card_title: "Calculator Inputs",
        investment_amount: "INVESTMENT AMOUNT",
        province: "PROVINCE",
        asset_mix: "ASSET MIX",
        cohort_priorities: "COHORT PRIORITIES",
        total: "Total",
        cancel_button: "Cancel",
        save_button: "Save",
        asset_mix_warning: "Asset mix total must be",
        you_are_at: "You are currently at",
      },
      ui_config: {
        header_icon_class: "bi bi-gear-fill",
      },
      currency_symbol: "R",
      investment_amount: 1000000,
      investment_amount_presets: [
        { label: "R100K", value: 100000 },
        { label: "R500K", value: 500000 },
        { label: "R1.0M", value: 1000000 },
        { label: "R5.0M", value: 5000000 },
      ],
      selected_province: "Western Cape (98%)",
      provinces: [
        { label: "Western Cape (98%)", value: "Western Cape (98%)" },
        { label: "Gauteng (95%)", value: "Gauteng (95%)" },
        { label: "KwaZulu-Natal (90%)", value: "KwaZulu-Natal (90%)" },
      ],
      assets: LEGACY_CARDS.map(card => ({
        key: card.key,
        label: card.name.replace("Mobile ", "").replace("Cart", "").replace(" Kit", ""),
        icon: card.icon,
      })),
      asset_mix: {
        food_security: 42,
        digital_inclusion: 35,
        creative_economy: 20,
        ngo_digitization: 5,
      },
      cohort_options: [
        { key: "youth", label: "Youth", bonus_label: "+20%", enabled_class: "btn-success-custom" },
        { key: "women", label: "Women", bonus_label: "+15%", enabled_class: "btn-success-custom" },
        { key: "pwd", label: "PWD", bonus_label: "+25%", enabled_class: "btn-secondary-custom" },
      ],
      enabled_cohorts: ["youth", "women"],
    });
  },

  computed: {
    formatted_investment_amount() {
      return new Intl.NumberFormat("en-ZA").format(this.investment_amount);
    },
    asset_mix_total() {
      return Object.values(this.asset_mix).reduce((sum, val) => sum + val, 0);
    },
  },

  watch: {
    investment_amount() { this.emit_inputs_changed(); },
    selected_province() { this.emit_inputs_changed(); },
    enabled_cohorts: { handler() { this.emit_inputs_changed(); }, deep: true },
    asset_mix: { handler() { this.emit_inputs_changed(); }, deep: true },
  },

  mounted() {
    // emit initial payload on load
    this.emit_inputs_changed();
  },

  methods: {
    build_payload() {
      return ({
        investment_amount: Number(this.investment_amount || 0),
        selected_province: this.selected_province,
        asset_mix: { ...this.asset_mix },
        enabled_cohorts: [...this.enabled_cohorts],
        asset_mix_total: this.asset_mix_total,
      });
    },

    emit_inputs_changed() {
      this.$emit("inputs-changed", this.build_payload());
    },

    set_investment_amount(value) {
      this.investment_amount = Number(value || 0);
    },

    handle_investment_amount_input(event) {
      const val = String(event.target.value || "").replace(/\D/g, "");
      this.investment_amount = parseInt(val, 10) || 0;
    },

    handle_asset_mix_input(key, event) {
      const valid_keys = ["food_security", "digital_inclusion", "creative_economy", "ngo_digitization"];
      if (valid_keys.includes(key)) {
        this.asset_mix[String(key)] = parseInt(event.target.value, 10) || 0;
      }
    },

    is_cohort_enabled(key) {
      return this.enabled_cohorts.includes(key);
    },

    toggle_cohort(key) {
      const index = this.enabled_cohorts.indexOf(key);
      if (index > -1) this.enabled_cohorts.splice(index, 1);
      else this.enabled_cohorts.push(key);
    },

    submit_calculator_inputs() {
      // optional "submit" action - live updates already happen
      console.log("Submitting:", this.build_payload());
      this.$emit("submit", this.build_payload());
    },

    cancel_calculator_inputs() {
      this.$emit("close");
    },
  },
};